import { captureException, captureMessage } from '@sentry/react';

export const logException = (exception, tags = {}) => {
    captureException(exception, {
        tags,
    });
};
export const logMessage = (message, tags) => {
    captureMessage(message, {
        tags,
    });
};
